const TABLET_VIEWPORT_WIDTH = 768;
const SMALL_DESKTOP_VIEWPORT_WIDTH = 1050;

export { TABLET_VIEWPORT_WIDTH, SMALL_DESKTOP_VIEWPORT_WIDTH };
